export default __webpack_public_path__ + "static/media/multi-users.1c777c7f.svg";